import { useQuery } from '@tanstack/react-query';

import { getQuoteItemColumnsKey, useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { QuoteItemColumnsKey, ViewsColumnData } from './types';

export const useGetQuoteItemColumns: QueryFunction<
  ViewsColumnData,
  [],
  QuoteItemColumnsKey
> = (params = {}) => {
  const { requestOptions } = params;
  const request = useRequest(requestOptions);
  const queryKey = getQuoteItemColumnsKey();

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/display_configs/quote_items`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
